import { AnimatePresence, motion } from "framer-motion";
import { ResultsEntity } from "typings/Database/Results";
import Counter from "../Counter/Counter";
import DataVisual from "../DataVisual/DataVisual";
import styles from "./Slide.module.scss";

const delay = 0.5;
export default function Slide({
  slide,
  isActive,
}: {
  slide: ResultsEntity;
  isActive: boolean;
}) {
  return (
    <div className={styles.slide}>
      <DataVisual isActive={isActive} percentage={slide.percentage} />
      <div className={styles.text}>
        <AnimatePresence>
          {isActive && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ delay: delay, transition: 1 }}
            >
              <Counter delay={delay} symbol="%" number={slide.percentage} />
            </motion.div>
          )}
        </AnimatePresence>
        <h2>{slide.text}</h2>
      </div>
    </div>
  );
}
